module.exports = __webpack_public_path__ + "img/instagram.3c945c48.png";